import { LinkedRecordObject } from "../../../types/form";

/**
 * Normalizes the linked record form value (array, single object, or array of IDs) into a list of record IDs.
 */
export function getLinkedRecordIds(value: unknown): string[] {
  if (value == null) return [];
  if (Array.isArray(value)) {
    return value
      .map((item) => {
        if (typeof item === "object" && item != null && "id" in item) {
          return (item as LinkedRecordObject).id;
        }
        if (typeof item === "string") return item;
        return null;
      })
      .filter((id): id is string => Boolean(id));
  }
  if (
    typeof value === "object" &&
    "id" in value &&
    typeof (value as LinkedRecordObject).id === "string"
  ) {
    return [(value as LinkedRecordObject).id];
  }
  return [];
}
